export const getImageUrl = (imagePath) => {
    try {
        if (imagePath?.startsWith('http')) {
            return imagePath;
        }
        
        const trailImages = {
            'parquedacidade.png': require('../img/trail-images/parquedacidade.png'),
            'fozdodouro.png': require('../img/trail-images/fozdodouro.png'),
            'matosinhos.png': require('../img/trail-images/matosinhos.png'),
            'valongo-trail.jpeg': require('../img/trail-images/valongo-trail.jpeg'),
            'trilhodosromanos.png': require('../img/trail-images/trilhodosromanos.png'),
            'parcdesbutteschaumont-paris.webp': require('../img/trail-images/parcdesbutteschaumont-paris.webp'),
            'castelinho.jpg': require('../img/trail-images/castelinho.jpg'),
            
            'Parque da cidade.jpeg': require('../img/trail-maps/Parque da cidade.jpeg'),
            'Foz do duoro.jpeg': require('../img/trail-maps/Foz do duoro.jpeg'),
            'Matosinhos.jpeg': require('../img/trail-maps/Matosinhos.jpeg'),
            'Trilhos dos Romanos.jpeg': require('../img/trail-maps/Trilhos dos Romanos.jpeg'),
            'Valongo - rio simao.jpeg': require('../img/trail-maps/Valongo - rio simao.jpeg'),
            'parcdesbutteschaumont-paris.png': require('../img/trail-maps/parcdesbutteschaumont-paris.png'),
            'castelinho-map.jpg': require('../img/trail-maps/castelinho-map.jpg'),
        };
        
        const filename = imagePath.split('/').pop();
        
        if (trailImages[filename]) {
            return [filename];
        }
        
        return imagePath;
        
    } catch (error) {
        console.error(`Error loading image: ${imagePath}`, error);
        return ''; 
    }
}; 